const state = {
  categoriasData: [
    {
      id: 1,
      codigo: 'xkgs',
      categoria: 'Servicio por kilo',
      tipo: 'servicios',
      descripcion: 'Lavado de ropa por kilo',
      minimo: 4,
      unidad: 'kilo',
      imagen: '',
      fecha: '2021-04-15 14:50:53'
    },
    {
      id: 2,
      codigo: 'quimicos',
      categoria: 'Químicos',
      tipo: 'productos',
      descripcion: 'Químico extra ',
      minimo: 1,
      unidad: '100ml',
      imagen: '',
      fecha: '2021-06-05 22:10:27'
    },
    {
      id: 3,
      codigo: 'servicios',
      categoria: 'Lavado Por Carga',
      tipo: 'servicios',
      descripcion: 'Lavado de ropa por carga ',
      minimo: 1,
      unidad: 'carga',
      imagen: '',
      fecha: '2021-06-05 22:10:27'
    },
  ],
};

const getters = {
  demoCategorias: state => state.categoriasData,
  servicesCategories: state => {
    const filteredServiceCategories = [...state.categoriasData.filter(categoria => categoria.tipo == 'servicios')];
    return filteredServiceCategories;
  },
  productCategories: state => {
    const filteredProductCategories = [...state.categoriasData.filter(categoria => categoria.tipo == 'productos')];
    return filteredProductCategories;
  },
};

export default{
  state,
  getters
};